/**
 * EgoDeviceListView Component
 *
 * Displays a searchable list of all eGO devices.
 * Each row links to /ego/{deviceId}.
 *
 * Requirements: 3.1, 3.2, 3.3, 3.4, 3.5
 */

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useEgoDevices } from '../hooks/useEgoDevices';
import './EgoDeviceListView.css';

export function EgoDeviceListView(): JSX.Element {
  const { devices, isLoading, error } = useEgoDevices();
  const [search, setSearch] = useState('');

  if (isLoading) {
    return (
      <div className="ego-list" role="status">
        <p className="ego-list__loading">Loading devices…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ego-list">
        <p className="ego-list__error" role="alert">{error}</p>
      </div>
    );
  }

  const deviceList = Array.isArray(devices) ? devices : [];
  const filtered = deviceList.filter((d) => {
    const term = search.toLowerCase();
    return (
      d.deviceId.toLowerCase().includes(term) ||
      d.config.siteId.toLowerCase().includes(term) ||
      d.config.bayId.toLowerCase().includes(term)
    );
  });

  return (
    <div className="ego-list">
      <h1 className="ego-list__title">eGO Devices</h1>
      <input
        className="ego-list__search"
        type="text"
        placeholder="Search devices…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        aria-label="Search devices"
      />
      <ul className="ego-list__items">
        {filtered.map((device) => (
          <li key={device.deviceId} className="ego-list__item">
            <Link to={`/ego/${device.deviceId}`} className="ego-list__link">
              <span className="ego-list__device-id">{device.deviceId}</span>
              <span className="ego-list__site-id">{device.config.siteId}</span>
              <span className="ego-list__bay-id">{device.config.bayId}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
